import React, { useState } from "react";
import { formatTimestamp } from "../../components/Shared/SharedMethods";
import { DeleteIcon, EditIcon } from "../../components/Shared/TableActionIcons";

import { useDispatch } from "react-redux";
import CustomPagination from "../../components/Shared/CustomPagination";
import { useTranslation } from "react-i18next";
import { deleteCustomer } from "../../store/slices/CustomerSlice";
import ConfirmationModal from "../../components/Shared/ConfirmationModal";
import TableLoading from "../../components/Shared/TableLoading";
import CustomTable from "../../components/Shared/CustomTable";
import { useNavigate } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";

export default function CustomerTable({ data, loading, onPageChange, onRefresh }) {
  const datebody = (rowData) => {
    return formatTimestamp(rowData.CreatedAt);
  };
  const [selectedData, setSelectedData] = useState(null);
  const [confirmationDialogVisible, setConfirmationDialogVisible] =
    useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handlePageChange = (newPage, newRowsPerPage) => {
    if (onPageChange) {
      onPageChange(newPage, newRowsPerPage);
    }
  };

  const templateBody = (rowData) => (
    <div className="flex gap-1">
      <EditIcon
        onClick={() => {
          navigate("/manager/customers/create", {
            state: { editData: rowData },
          });
        }}
        title={t("edit")}
      />
      <DeleteIcon
        onClick={() => {
          setConfirmationDialogVisible(true);
          setSelectedData(rowData);
        }}
        title={t("delete")}
      />
    </div>
  );

  const sequenceBodyTemplate = (rowData, options) => {
    const page = data?.page || 1;
    const perPage = data?.per_page || 10;
    return options.rowIndex + 1 + (page - 1) * perPage;
  };

  const confirmDeleteHandler = () => {
    if (selectedData) {
      dispatch(deleteCustomer({ id: selectedData.id })).then((res) => {
        if (onRefresh) onRefresh();
      });
      setConfirmationDialogVisible(false);
      setSelectedData(null);
    }
  };

  const columnsData = [
    {
      body: templateBody,
      header: t("actions"),
    },
    {
      body: sequenceBodyTemplate,
      header: t("no"),
      style: { width: "3rem" },
    },
    {
      field: "name",
      header: t("name"),
    },
    {
      field: "document_id",
      header: t("document_id"),
    },
    {
      field: "primary_contact_number",
      header: t("primaryContactNumber"),
    },
    {
      field: "primary_email_id",
      header: t("primaryEmailId"),
    },
    {
      field: "status",
      header: t("status"),
    },
  ];

  return (
    <>
      <CustomTable
        data={data?.data}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        rows={data?.per_page}
      />
      <ConfirmationModal
        message={`${t("do_you_really_want_to_delete_this_customer")} "${selectedData?.name}"?`}
        header={t("delete_confirmation")}
        Icon={FiTrash2}
        visible={confirmationDialogVisible}
        setVisible={setConfirmationDialogVisible}
        onAccept={confirmDeleteHandler}
        acceptLabel={t("delete")}
        rejectLabel={t("cancel")}
      />
      {data?.data?.length > 0 && (
        <CustomPagination
          currentPage={data?.page}
          rowsPerPage={data?.per_page}
          totalRecords={data?.total_pages}
          totalRecord={data?.total_record}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
}
